import {
    AppBar,
    Box,
    Button,
    FormControl,
    IconButton,
    InputLabel,
    MenuItem,
    Select, SelectChangeEvent,
    Toolbar,
    Typography
} from "@mui/material";
import MenuIcon from "@mui/icons-material/Menu";
import * as React from "react";
import {useAccount, useMsal} from "@azure/msal-react";
import { useTranslation } from 'react-i18next';

interface ApplicationBarProps {
    onLocaleSwitched :  ((e: SelectChangeEvent<String>) => void);
    locale: String;
}

export default function ApplicationBar({onLocaleSwitched, locale} : ApplicationBarProps) {
    const account = useAccount();
    const {instance, inProgress} = useMsal();
    const { t, i18n } = useTranslation();


    return (
        <Box sx={{flexGrow: 1}}>
            <AppBar position="static">
            <Toolbar>
                <IconButton
                    size="large"
                    edge="start"
                            color="inherit"
                            aria-label="menu"
                            sx={{ mr: 2 }}>
                    <MenuIcon />
                </IconButton>
                <Typography variant="h6" component="div" sx={{ flexGrow: 1 }}>
                    {t('applicationName')}
                </Typography>
                <FormControl sx={{ m: 1, minWidth: 120 }} size="small">
                    <InputLabel id="demo-select-small-label">{t('common.locale')}</InputLabel>
                    <Select
                        labelId="demo-select-small-label"
                        id="demo-select-small"
                        value={locale}
                        label={t('common.locale')}
                        onChange={onLocaleSwitched}
                    >
                        <MenuItem value={'en-US'}>English</MenuItem>
                        <MenuItem value={'ja-JP'}>日本語</MenuItem>
                        <MenuItem value={'ko-KR'}>한국어</MenuItem>
                        <MenuItem value={'zh-TW'}>國語</MenuItem>
                    </Select>
                </FormControl>
                <Button color="inherit">{account?.name}</Button>
            </Toolbar>
            </AppBar>
        </Box>
    );
}